import { api } from '@/core/api'
import type { AuthTokens, LoginCredentials, TokenVerify } from '../models/auth'

interface ErrorResponse {
  detail?: string
}

const isErrorResponse = (response: any): response is ErrorResponse => {
  return response && typeof response === 'object' && 'detail' in response
}

export const login = async (credentials: LoginCredentials) => {
  const response = await api.Post<AuthTokens | ErrorResponse>('/v1/api/auth/token/', credentials)

  if (isErrorResponse(response)) {
    throw new Error(response.detail || 'Erro ao fazer login')
  }

  if (!response.access || !response.refresh) {
    throw new Error('Resposta inválida do servidor')
  }

  return response
}

export const verifyToken = async (token: string) => {
  const response = await api.Post<void | ErrorResponse>('/v1/api/auth/token/verify/', {
    token,
  } as TokenVerify)

  if (isErrorResponse(response)) {
    throw new Error(response.detail || 'Token inválido')
  }
}

export const refreshToken = async (refresh: string) => {
  const response = await api.Post<AuthTokens | ErrorResponse>('/v1/api/auth/token/refresh/', {
    refresh,
  })

  if (isErrorResponse(response)) {
    throw new Error(response.detail || 'Erro ao renovar token')
  }

  if (!response.access || !response.refresh) {
    throw new Error('Resposta inválida do servidor')
  }

  return response
}
